import { observer } from "mobx-react-lite";
import { useManageFashionInspirationStore } from "../../ManageFashionInspirationStore";
import Header, { TitleText } from "csi/page/Header";
import FullScreenDialog from "designSystem/components/dialog/FullScreenDialog";
import React, { useEffect } from "react";
import { useStore } from "csi/state/hooks";
import { IconButton } from "designSystem/index";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./IFrameDialog.module.css";
import { IFRAME_ID } from "../../constants";
import { useEventListener } from "designSystem/hooks";

const IFrameDialog = observer(() => {
	const fashionInspirationStore = useManageFashionInspirationStore();
	const { routerStore } = useStore();
	const { locationName } = routerStore;
	const { iframeUrl, openIFrameDialog, setCloseIframeDialog, showIframe, handleIFrameMessage } = fashionInspirationStore;

	// This listener will be used to send and receive data from Fashion Inspiration IFrame page.
	useEventListener("message", handleIFrameMessage);

	const headerRightChildren = (
		<IconButton
			className={styles.closeIconButton}
			design="iconOnlyOnColor"
			onClick={setCloseIframeDialog}
			size="large"
		>
			<CloseIcon className={styles.closeIcon} />
		</IconButton>
	);

	const headerLeftChildren = (
		<TitleText
			className={styles.subTitle}
			text={locationName}
			variant="h5"
		/>
	);

	return (
		<FullScreenDialog onClose={setCloseIframeDialog} open={openIFrameDialog}>
			<Header
				leftChildren={headerLeftChildren}
				rightChildren={headerRightChildren}
				title="Fashion Inspiration"
			/>
			{showIframe && (
				<iframe
					allowFullScreen
					className={styles.iFrame}
					id={IFRAME_ID}
					src={iframeUrl}
				/>
			)}
		</FullScreenDialog>
	);
});

export default IFrameDialog;
